import React, { useCallback, useState } from 'react';
import { Controlled as ControlledZoom } from 'react-medium-image-zoom';
import { MagnifyingGlassPlusIcon } from '@heroicons/react/24/outline';
import { useSelector } from 'react-redux';
import { ZoomImageContainer } from '../regularStyles';
import { ZoomButtonWrapper } from '../../../productConfig/productConfigStyles';

const ProductZoomImage: React.FC = () => {
  const product = useSelector(
    (state: any) => state.productConfig.currentProduct,
  );

  const [isZoomed, setIsZoomed] = useState(false);

  const handleZoomChange = useCallback((shouldZoom: boolean) => {
    setIsZoomed(shouldZoom);
  }, []);

  const handleZoomClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    setIsZoomed((zoomed) => !zoomed);
  };

  if (!product) return null;

  return (
    <ZoomImageContainer>
      <ControlledZoom
        zoomImg={{ src: product.image_large }}
        isZoomed={isZoomed}
        onZoomChange={handleZoomChange}
      >
        <img
          className="bnl-product-config__product-image"
          src={product.image_thumbnail}
        />
      </ControlledZoom>
      <ZoomButtonWrapper onClick={handleZoomClick}>
        <MagnifyingGlassPlusIcon />
      </ZoomButtonWrapper>
    </ZoomImageContainer>
  );
};

export default ProductZoomImage;
